"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const uuid_1 = require("uuid");
const CardResults_1 = __importDefault(require("@Components/CardResults"));
const WorkResultsTable = (props) => {
    const { works, paginationInfo, limit, onChangePage, compact, fetchType, onChangeLimit, claimedShares, compactWorkComponentType, extendedWorkComponentType, noResultsInfo, showCompactToggle, bulkActionControlSection, } = props;
    const workItemDataList = (works === null || works === void 0 ? void 0 : works.works.map((work) => {
        var _a;
        const yourShare = (_a = claimedShares === null || claimedShares === void 0 ? void 0 : claimedShares.workClaimedShares) === null || _a === void 0 ? void 0 : _a.find((share) => share.id === work.id);
        return {
            work: work,
            fetchType: fetchType,
            yourShares: yourShare && yourShare.rightsholderClaimedShare,
            getId: () => work.id || (0, uuid_1.v4)(),
        };
    })) || [];
    return (react_1.default.createElement(CardResults_1.default, { data: workItemDataList, paginationInfo: paginationInfo, count: works ? works.count : 0, limit: limit, onChangePage: onChangePage, compact: compact, onChangeLimit: onChangeLimit, compactCardType: compactWorkComponentType, extendedCardType: extendedWorkComponentType, noResultsInfo: noResultsInfo, showCompactToggle: showCompactToggle, bulkActionControlSection: bulkActionControlSection }));
};
exports.default = WorkResultsTable;
